import React, { useEffect, useState } from 'react';
import axios from "axios";
import { Tooltip } from "react-tooltip";
import configApi from "../../config";

const PatientStats = () => {
  const [patients, setPatients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    fetchPatients();
  }, []);

  const fetchPatients = async () => {
    try {
      const response = await axios.get(
        `${configApi.apiEndpoint}/api/Patients`,
        config
      );
      setPatients(response.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="metric-card w-100 h-100">
        <div className="skeleton-circle"></div>
        <div className="metric-data gap-2">
          <div className="skeleton-box" style={{ width: '60px', height: '28px' }}></div>
          <div className="skeleton-box" style={{ width: '100px', height: '14px' }}></div>
        </div>
      </div>
    );
  }

  return (
    <div className="metric-card w-100 h-100">
      <div className="metric-icon" style={{ backgroundColor: '#fce4ec', color: '#c2185b' }}>
        <i className="bi bi-people"></i>
      </div>
      <div className="metric-data">
        <h3 className="fw-bold m-0 text-dark">{patients.length}</h3>
        <span
          className="text-muted"
          style={{ fontSize: '0.85rem', cursor: 'help', borderBottom: '1px dotted #ccc' }}
          data-tooltip-id="patient-stats-tooltip"
          data-tooltip-content="Celkový počet všetkých pacientov registrovaných v databáze CRM (vrátane tých, čo ešte nemali termín)."
        >
          Registrovaní pacienti
        </span>
      </div>
      <Tooltip id="patient-stats-tooltip" place="top" effect="solid" />
    </div>
  );
};

export default PatientStats;
